module.exports = __webpack_public_path__ + "img/2.fb107423.jpg";